import { Link } from 'react-router-dom'
import type { Skill } from '@/types'
import { SkillActionsMenu } from './SkillActionsMenu'
import { SkillCategoryBadge, SkillVersionBadge } from './SkillBadges'

interface SkillRowProps {
  projectId: string
  skill: Skill
}

export function SkillRow({ projectId, skill }: SkillRowProps) {
  const detailPath = `/projects/${projectId}/workflows/skills/${skill.id}`

  return (
    <div
      className="relative flex items-center justify-between gap-2 rounded-2xl border border-border bg-card px-4 py-3 transition-colors hover:bg-muted/30"
      data-testid={`skill-row-${skill.name}`}
    >
      <div className="min-w-0 flex-1">
        <span className="flex flex-wrap items-center gap-2">
          <span className="truncate text-base font-bold text-foreground">
            <Link
              to={detailPath}
              className="rounded-sm after:absolute after:inset-0 after:content-[''] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              {skill.displayName}
            </Link>
          </span>
          <SkillCategoryBadge skill={skill} />
          {skill.latestVersion && <SkillVersionBadge version={skill.latestVersion} />}
        </span>
        {skill.description && <span className="mt-1 block max-w-[80ch] truncate text-sm text-muted-foreground">{skill.description}</span>}
        <span className="mt-0.5 block font-mono text-xs text-muted-foreground">{skill.name}</span>
      </div>
      <div className="relative z-10">
        <SkillActionsMenu projectId={projectId} skill={skill} />
      </div>
    </div>
  )
}
